import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
} from '@material-ui/core';
import { Content, Header, LinkButton, Page } from '@backstage/core-components';

export const ContactPage = () => {
  return (
    <Page themeId="contact">
      <Header
        title="Contact"
        subtitle="Got a question about Irie, need support, or want to share feedback"
      />
      <Content>
        <Grid container>
          <Grid item xs={12} md={6} xl={4}>
            <Card style={{ height: '100%' }}>
              <CardHeader title="Email" />
              <Divider style={{ marginTop: 16 }} />
              <CardContent>
                Send us a message at <b>team-platform@nupis.de</b> – we’ll get
                back to you as soon as possible.
              </CardContent>
              <CardActions>
                <LinkButton color="primary" to="mailto:team-platform@nupis.de">
                  Write an email
                </LinkButton>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <Card style={{ height: '100%' }}>
              <CardHeader title="Teams" />
              <Divider style={{ marginTop: 16 }} />
              <CardContent>
                You can reach us via Microsoft Teams – just drop a message in
                the <b>N+P Plattform Dev Community</b> channels. Often, other
                members of the community are also happy to help and share their
                experience.
              </CardContent>
              <CardActions>
                <LinkButton
                  color="primary"
                  to="https://teams.microsoft.com/l/team/19%3AR4AsBK_nUaOJZYYM2QK22FeF1y13bzzinP1lDkWYsWs1%40thread.tacv2/conversations?groupId=6cab8382-32b8-4cf4-aba2-05e043159983&tenantId=b4f07ca6-0c49-4301-8a06-6db4548d6c0e"
                >
                  Join the community
                </LinkButton>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <Card style={{ height: '100%' }}>
              <CardHeader title="Jira" />
              <Divider style={{ marginTop: 16 }} />
              <CardContent>
                For feature requests, bug reports or technical questions, you
                can create a ticket directly. Use our <b>Platform </b> project
                in Jira.
              </CardContent>
              <CardActions>
                <LinkButton
                  color="primary"
                  to="https://nupis.atlassian.net/jira/software/c/projects/PF/boards/45/backlog?customFilter=653"
                >
                  Create a ticket
                </LinkButton>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
